/**
 * Module dependencies.
 */

import { Button } from 'app/components/atoms/button/button';
import { ExtraActionsProps } from 'app/components/organisms/crud/form-types';
import { useRecalculateBalances } from 'app/hooks/requests/bank-accounts/recalculate-balances';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Export `RecalculateBalancesAction` component.
 */

export function RecalculateBalancesAction({ refresh }: ExtraActionsProps): JSX.Element {
  const [translate] = useTranslation();
  const { mutateAsync: recalculateBalances, isLoading } = useRecalculateBalances();

  const handleClick = useCallback(async () => {
    try {
      // On success the global request handler shows the app's success toast; the
      // refresh reloads the list so the recalculated balances are visible.
      await recalculateBalances();

      await refresh();
    } catch {
      // Errors surface through the global request error handler.
    }
  }, [recalculateBalances, refresh]);

  return (
    <Button isLoading={isLoading} onClick={handleClick}>
      {translate('common.actions.recalculateBalances')}
    </Button>
  );
}
